import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { OVERLAY_SECTIONS } from '../mapSettingsConfig';
import LayerCard from './LayerCard';

interface OverlaysTabProps {
  selectedLayerTypes: Set<string>;
  onToggleLayer: (_layerName: string) => void;
}

const OverlaysTab: FC<OverlaysTabProps> = ({
  selectedLayerTypes,
  onToggleLayer,
}) => (
  <Box display="flex" flexDirection="column" gap="4">
    {OVERLAY_SECTIONS.map((section) => (
      <Box key={section.title} display="flex" flexDirection="column" gap="2">
        <Box fontWeight="bold" fontSize="15px" color="black">
          {section.title}
        </Box>
        {section.items.map((item) => (
          <LayerCard
            key={item.layerName}
            title={item.title}
            subtitle={item.subtitle}
            imageUrl={item.imageUrl}
            name={`map-layer-${item.layerName}`}
            selected={selectedLayerTypes.has(item.layerName)}
            subscriberOnly={item.subscriberOnly}
            onClick={() => onToggleLayer(item.layerName)}
          />
        ))}
      </Box>
    ))}
  </Box>
);

export default OverlaysTab;
